import { render, staticRenderFns } from "./StickersCarousel.vue?vue&type=template&id=f3ee51dc"
import script from "./StickersCarousel.vue?vue&type=script&lang=js"
export * from "./StickersCarousel.vue?vue&type=script&lang=js"
import style0 from "./StickersCarousel.vue?vue&type=style&index=0&id=f3ee51dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports